<script lang="ts" setup>
	const props = defineProps<{
		loading?: boolean
		columns: TableColumn[]
	}>()
	const tableLoader = useTemplateRef('loaderRef')
	const tableWrapper = useTemplateRef('wrapper')
	const { loading, columns } = toRefs(props)

	const totalRecords = shallowRef<number[]>([1, 2, 3])

	const { isOverflowing, scrollElement, showScrollLeft } = useOverflowDetection(tableLoader, {
		root: tableWrapper,
		observe: loading
	})

	onMounted(() => {
		if (Array.isArray(props.columns) && totalRecords.value.length < props.columns.length) {
			for (let index = 0; index < props.columns.length; index++) {
				totalRecords.value.push(index)
			}
		}
	})
</script>

<template>
	<div ref="wrapper" class="w-full">
		<div
			class="relative z-20 flex w-full justify-end py-2 pr-1 transition-all"
			:class="{ flex: isOverflowing, hidden: !isOverflowing }"
		>
			<button
				type="button"
				class="flex items-center gap-0.5 text-[14px] leading-[18px] text-gray-500"
				@click="() => scrollElement()"
			>
				<tools-icon
					dir="arrows"
					:icon="!showScrollLeft ? 'double-greater-than' : 'double-less'"
					:height="18"
					:width="18"
					class="animate-x"
				/>
				Scroll {{ showScrollLeft ? 'left' : 'right' }}
			</button>
		</div>

		<div ref="loaderRef" class="custom-scrollbar relative overflow-x-auto pb-10">
			<a-table v-if="loading" :columns="columns" :data-source="totalRecords" :pagination="false">
				<template #bodyCell>
					<loader-skeleton :count="1" :height="40" max-width />
				</template>
			</a-table>
			<div :class="{ 'absolute -z-0 opacity-0': loading }">
				<slot :columns="columns" />
			</div>
		</div>
	</div>
</template>
